<template>
  <div class="w-100 h-100">
    <Toast />
    <router-view></router-view>
  </div>
</template>

<script>
// import { setToken } from "./store/utils/auth.js";
import Toast from "./component/Toast/toast.vue";
export default {
  name: "App",
  components: {
    Toast,
  },
  async mounted() {
    const vm = this;
    // setToken(vm.$store.state.login_token);
    vm.$store.commit("set_lang", vm.lang);
    window.top.document.title = this.web_app;

    // const profile = await vm.$axios.post('user/detailUserByMasterUserId', {masterUserId: vm.$store.state.login_data_user.masterUserId})
    // if(profile.data.status == 200){
    //   vm.$store.commit("set_login_data_user", profile.data.data[0]);
    // }

    // const role = await vm.$axios.post('poolRole/listPoolRoleByMasterUserId', {masterUserId: vm.$store.state.login_data_user.masterUserId})
    // if(role.data.status == 200){
    //   for (let i = 0; i < role.data.data.length; i++) {
    //     const x = role.data.data[i];
    //     if(x.role.id == vm.$store.state.role_aktif.roleId)
    //   }
    //   vm.$store.commit("set_login_data_user", role.data.data);
    // }
  },
  watch: {
    web_app: function (newV, oldV) {
      if (newV != oldV) {
        window.top.document.title = newV;
      }
    },
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    },
    web_app() {
      return this.$store.state.mitra_aktif ? this.$store.state.mitra_aktif.namaApp : "STARA";
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&display=swap");

// Import Main styles for this application
@import "assets/scss/style";

// Apply font globally to the body
.custom-text {
  font-family: 'Manrope', sans-serif;
  letter-spacing: 0.7px;
}

// Table-specific styles
.table-number {
  width: 60px;
}

.table-option {
  width: 110px;
}

.table-option-1 {
  width: 100px;
}

.table-option-2 {
  width: 140px;
}

.table-option-3 {
  width: 180px;
}

.table-option-4 {
  width: 200px;
}

.table-option-5 {
  width: 260px;
}
</style>
